export default "__VITE_ASSET__BIkYr2Tt__"